import axios from 'axios';
export const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
export class LeadApiService {
}
LeadApiService.baseUrl = process.env.REACT_APP_API_BASE_URL;
LeadApiService.getDocumentList = (leadID, token, agent) => {
    const url = `${LeadApiService.baseUrl}/sme-api/lead/${leadID}/document`;
    return axios.get(url, {
        headers: {
            user: agent,
            token: token,
        },
    });
};
LeadApiService.uploadCategoryDocument = (req, leadId, cmpanyId, token, agent) => {
    const apiReq = {
        "companyId": cmpanyId,
        "marketRenewalDoc": {
            [`${req.category}`]: {
                "displayName": `${req.category}_${cmpanyId}.${req.documentType}`,
                "documentType": req.documentType,
                "documentImage": req.documentImage
            }
        }
    };
    const url = `${LeadApiService.baseUrl}/sme-api/lead/update/${leadId}`;
    return axios.post(url, apiReq, {
        headers: {
            user: agent,
            token: token,
        },
    });
};
LeadApiService.deleteCategoryDocument = (category, leadId, documentId, token, agent) => {
    const url = `${LeadApiService.baseUrl}/sme-api/lead/${leadId}/document/${documentId}`;
    return axios.post(url, {}, {
        headers: {
            user: agent,
            token: token,
        },
        params: {
            docType: category
        }
    });
};
